// extracted by mini-css-extract-plugin
export default {"titleLegend":"vessel-conductor_record_titleLegend__C-zdl"};